import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "-3 0 31 24",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M8.18 1.5h1A2.86 2.86 0 0 1 12 4.36v1H8.18V1.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M14.86 1.5h1v3.82H12v-1a2.86 2.86 0 0 1 2.86-2.82Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      d: "M15.89 5.32H8.11A5.59 5.59 0 0 0 3.24 8a13 13 0 0 0-1.74 6.54v6.05h3.82a1.9 1.9 0 0 0 1.91 1.91h9.54a1.9 1.9 0 0 0 1.91-1.91h3.82v-6.05A13 13 0 0 0 20.76 8a5.59 5.59 0 0 0-4.87-2.68ZM5.32 11.05v9.54M18.68 11.05v9.54M12 5.32V22.5M9.14 17.73H5.32M18.68 17.73h-3.82"
    }, null, -1)
  ])))
}
export default { render };